import {
  createResource,
  deleteResource,
  determinePaginationParams,
  determineSelector,
  getResource,
  readUrl,
  throwOnApiError,
  updateResource,
} from "./api";

// Fetches ALL of a media profile's jobs (no pagination), newest first — the provider owns the
// collection (it backs the Publications section), so it must return the complete, ordered set.
const getAllByMediaProfile = async (mediaProfileId) => {
  const selector = determineSelector(mediaProfileId, { keyId: "media_profile_id" });
  const url = readUrl("media_jobs", { selector: `${selector}&order=started_at.desc` });
  return getResource(url);
};

// One page of an outlet's CURRENT roster. media_jobs is employment history, so "works here now" is
// the rows with no end date. The view declares no ordering and started_at is nullable and
// non-unique, so paging needs a total order: media_profile_id then id. A profile can hold more than
// one concurrent job at the same outlet, so pages can repeat a profile — the caller dedupes.
const getAllCurrentByMediaOutlet = async (mediaOutletId, options = {}) => {
  const paginationParams = determinePaginationParams(options);
  const selector = `media_outlet_id=eq.${mediaOutletId}&ended_at=is.null&order=media_profile_id.asc,id.asc`;
  const url = readUrl("media_jobs", { selector, paginationParams });
  return getResource(url);
};

const createMediaProfileJob = async (mediaOutletId, profileIdOrSlug, attributes) => {
  const url = `/id/api/user_profiles/${profileIdOrSlug}/media_jobs`;
  // Check for `{ error }` BEFORE unwrapping to attributes — otherwise a failed create returns
  // `undefined` and the caller can't tell success from failure.
  const response = throwOnApiError(await createResource(url, { data: { attributes } }));
  return response?.data?.data?.attributes;
};

const updateByProfileIdAndId = async (profileId, id, attributes) => {
  const url = `/id/api/user_profiles/${profileId}/media_jobs/${id}`;
  return throwOnApiError(await updateResource(url, { data: { attributes } }));
};

const deleteMediaJobById = async (profileIdOrSlug, id) => {
  const url = `/id/api/user_profiles/${profileIdOrSlug}/media_jobs/${id}`;
  return throwOnApiError(await deleteResource(url));
};

export default {
  createMediaProfileJob,
  deleteMediaJobById,
  getAllByMediaProfile,
  getAllCurrentByMediaOutlet,
  updateByProfileIdAndId,
};
